import React from 'react';
import { ToastContainer } from 'react-toastify';
import GivingCampaignDetail from '../components/GivingCampaignDetail';

const GivingCampaignDetailApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <GivingCampaignDetail {...props} />
  </>
);

export default GivingCampaignDetailApp;
